import type { HTMLWidget } from "~/types/widgets";
import { useId } from "react";
import Slider from "~/components/ui/Slider";
import SliderJS from "~/components/ui/SliderJS";
import { stripInlineStyles } from "~/utils/richText";
import { RULES_TEXT_CLASSES } from "./rulesBarTextClasses";

export const eager = true;
export const sync = true;

interface Props {
  rules: Rule[];
  /**
   * @title Intervalo do carrossel (mobile)
   * @description Segundos entre cada benefício no carrossel mobile. 0 desliga o autoplay.
   * @default 3
   */
  interval?: number;
}

interface Rule {
  content: HTMLWidget;
}

function RuleContent({ rule }: { rule: Rule }) {
  return (
    <div
      className={`font-['Poppins'] not-italic text-[#333333] ${RULES_TEXT_CLASSES}`}
      dangerouslySetInnerHTML={{ __html: stripInlineStyles(rule.content) }}
    />
  );
}

function RulesBar({ rules, interval = 3 }: Props) {
  const id = useId();

  if (!rules?.length) return null;

  return (
    <section>
      {/* Mobile: carrossel, um benefício por vez */}
      <div id={id} className="lg:hidden w-full bg-[#F0F0F0] mb-2">
        <Slider className="carousel carousel-center w-full py-4">
          {rules.map((rule, index) => (
            <Slider.Item
              key={index}
              index={index}
              className="carousel-item w-full flex flex-col items-center justify-center text-center px-2"
            >
              <RuleContent rule={rule} />
            </Slider.Item>
          ))}
        </Slider>
        {rules.length > 1 && (
          <SliderJS rootId={id} interval={interval > 0 ? interval * 1e3 : undefined} infinite />
        )}
      </div>

      {/* Desktop: todos os benefícios lado a lado */}
      <ul className="hidden lg:flex w-full py-4 flex-wrap justify-around gap-y-2 bg-[#F0F0F0] mb-2">
        {rules.map((rule, index) => {
          return (
            <li key={index} className="flex-1 basis-0 flex flex-col items-center text-center px-2">
              <RuleContent rule={rule} />
            </li>
          );
        })}
      </ul>
    </section>
  );
}

export default RulesBar;
